import React, { useState } from 'react';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ConfirmationModal from '../../../common/modal/ConfirmationModal';
import { deleteShelf } from '../../../../actions';

const ShelfDeleteButton = ({ dispatchDeleteShelf, shelfId, disabled }) => {
  const [showModal, setShowModal] = useState(false);

  const onClickDelete = () => dispatchDeleteShelf({ shelfId });

  const openModal = () => setShowModal(true);

  const closeModal = () => setShowModal(false);

  return (
    <>
      <ConfirmationModal
        show={showModal}
        onClickConfirm={onClickDelete}
        onClickCancel={closeModal}
      />
      <Button color="danger" onClick={openModal} disabled={disabled}>
        <i className="fa fa-trash-o" /> Eliminar
      </Button>
    </>
  );
};

ShelfDeleteButton.propTypes = {
  dispatchDeleteShelf: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  shelfId: PropTypes.number.isRequired,
};

ShelfDeleteButton.defaultProps = {
  disabled: false,
};

const mapDispatchToProps = {
  dispatchDeleteShelf: deleteShelf,
};

export default connect(null, mapDispatchToProps)(ShelfDeleteButton);
